export type PageLocale = "en" | "es";

export const PAGE_META: Record<
  PageLocale,
  { title: string; description: string }
> = {
  en: {
    title: "Eloria",
    description:
      "Eloria web panel for property managers — manage buildings, contacts, and WhatsApp conversations.",
  },
  es: {
    title: "Eloria",
    description:
      "Panel web de Eloria para administradores de propiedades — gestioná edificios, contactos y conversaciones de WhatsApp.",
  },
};

export function resolvePageLocale(
  lang: string | null | undefined,
): PageLocale {
  if (lang === "es") return "es";
  if (typeof window !== "undefined") {
    const urlLang = new URLSearchParams(window.location.search).get("lang");
    if (urlLang === "es") return "es";
    const nav = (navigator.language || "").toLowerCase();
    if (nav.startsWith("es")) return "es";
  }
  return "en";
}

export function applyPageMeta(locale: PageLocale): void {
  const { title, description } = PAGE_META[locale];
  document.documentElement.lang = locale;
  document.title = title;

  const setContent = (selector: string, content: string) => {
    const el = document.querySelector<HTMLMetaElement>(selector);
    if (el) el.content = content;
  };

  setContent('meta[name="description"]', description);
  setContent('meta[property="og:title"]', title);
  setContent('meta[property="og:description"]', description);
  setContent('meta[name="twitter:title"]', title);
  setContent('meta[name="twitter:description"]', description);
}
